var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider"},[(_vm._text)?_c('div',{staticClass:"text",domProps:{"textContent":_vm._s(_vm._text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }